import PassportReviewItem from "./PassportReviewItem";

export default PassportReviewItem;